import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ForumState {
  discussion: Record<any, any>;
}

const initialState: ForumState = {
  discussion: {},
};

export const discussionSlice = createSlice({
  name: "discusstion",
  initialState,
  reducers: {
    setDiscussion: (state, action: PayloadAction<Record<string, any>>) => {
      state.discussion = action.payload;
    },
  },
});

export const { setDiscussion } = discussionSlice.actions;
export default discussionSlice.reducer;
